export default {
  // Common
  common: {
    unknown: 'Unknown',
    none: 'None',
    optional: 'Optional',
    default: 'Default',
    unlimited: 'Unlimited',
    loading: 'Loading...',
    processing: 'Processing...',
    searching: 'Searching...',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    copy: 'Copy',
    success: 'Success',
    failed: 'Failed',
    error: 'Error',
    submit: 'Submit',
    search: 'Search',
    reset: 'Reset',
    save: 'Save',
    refresh: 'Refresh',
    previous: 'Previous',
    next: 'Next',
    pageInfo: 'Page {current} of {total}',
    note: 'Note',
    tip: 'Tip',
    loadingMore: 'Loading more...',
    noMoreData: 'No more data',
    yuan: 'CNY'
  },

  // Brand
  brand: {
    name: 'UltraThink',
    logo: 'UltraThink Logo',
    description: 'UltraThink is a privacy-focused data sharing platform that provides secure and convenient data sharing services for users.',
    copyright: 'UltraThink. All rights reserved.'
  },

  // Navigation
  nav: {
    home: 'Home',
    receiveData: 'Receive SMS',
    mailReceive: 'Email Codes',
    receiveRecords: 'Records',
    faq: 'FAQ',
    referralRewards: 'Referrals',
    apiDocs: 'API',
    desktopDownload: 'Desktop',
    ticketCenter: 'Tickets',
    more: 'More',
    messageProcessing: 'Messages',
    login: 'Login',
    userCenter: 'Profile',
    logout: 'Logout',
    user: 'User'
  },

  // Page Titles
  titles: {
    home: 'UltraThink - Privacy-focused SMS Platform',
    login: 'Login - UltraThink',
    receiveCode: 'Receive SMS - UltraThink',
    mailReceive: 'Email Codes - UltraThink',
    receiveRecords: 'Records - UltraThink',
    messageProcessing: 'Messages - UltraThink',
    ticketCenter: 'Ticket Center - UltraThink',
    contact: 'Contact - UltraThink',
    mobileApp: 'Mobile App - UltraThink',
    desktopDownload: 'Desktop Download - UltraThink',
    faq: 'FAQ - UltraThink',
    referralRewards: 'Referrals - UltraThink',
    apiDocs: 'API - UltraThink',
    userCenter: 'Profile - UltraThink',
    notFound: 'Page Not Found - UltraThink'
  },

  // Email verification flow
  mailReceive: {
    title: 'Email Verification',
    subtitle: 'Choose a service and email domain to receive a temporary mailbox and verification code.',
    project: 'Service',
    projectPlaceholder: 'Select a service',
    domain: 'Email domain',
    domainPlaceholder: 'Select a domain',
    price: 'Your price',
    stock: 'Available',
    available: 'available',
    noStock: 'Out of stock',
    purchase: 'Get mailbox',
    purchaseWithPrice: 'Get mailbox for ¥{price}',
    priceTip: 'The displayed CNY price is charged after the first code is received.',
    orderTitle: 'Email orders',
    noOrders: 'No email orders yet',
    emailAddress: 'Temporary email',
    verificationCode: 'Verification code',
    createdAt: 'Created',
    expiresAt: 'Expires',
    expiresIn: 'Expires in',
    copy: 'Copy email',
    copied: 'Email address copied',
    cancel: 'Cancel order',
    canceled: 'Email order canceled',
    orderCreated: 'Mailbox created. Waiting for the verification code.',
    waitingCode: 'Waiting for code',
    settlementPending: 'Code received; supplier settlement is pending.',
    loading: 'Loading email data…',
    emptyProjects: 'No enabled email services',
    emptyDomains: 'No enabled email domains',
    loadFailed: 'Failed to load email data',
    priceFailed: 'Failed to load email price',
    orderFailed: 'Failed to get mailbox. Please try again.',
    cancelFailed: 'Cancellation failed. Please try again.',
    refresh: 'Refresh orders',
    status: {
      WAITING_CODE: 'Waiting for code',
      CANCELING: 'Canceling',
      CODE_RECEIVED: 'Code received',
      CANCELED: 'Canceled',
      ERROR: 'Failed',
      EXPIRED: 'Expired'
    }
  },

  // Home Page
  home: {
    heroTitle: 'Protect Your Privacy, Receive SMS Securely',
    heroSubtitle: 'UltraThink provides temporary phone numbers to receive SMS verification codes without exposing your personal information',
    startReceiving: 'Start Receiving SMS',
    learnMore: 'Learn More',
    blackFriday: {
      badge: '🔥 Black Friday is live this week',
      title: 'Top up anytime and enjoy 20% off',
      subtitle: 'Top up to join the campaign. Eligible channels automatically charge at the discounted price.',
      priceLabel: 'Activity Billing',
      priceText: '20% off campaign',
      originalLabel: 'Original price shown',
      cta: 'Get Discount Now',
      highlights: {
        auto: 'Auto activity pricing',
        channel: 'Live channel display',
        record: 'Visible receive records'
      }
    },
    whyChooseTitle: 'Why Choose UltraThink',
    whyChooseSubtitle: 'We provide secure and reliable data sharing services to protect your privacy',
    features: {
      instant: {
        title: 'Instant Reception',
        description: 'Receive SMS codes in real-time without waiting, making your registration and login process smoother'
      },
      allTime: {
        title: '24/7 Service',
        description: '24/7 uninterrupted service, meeting your data sharing needs anytime, anywhere'
      },
      privacy: {
        title: 'Privacy Protection',
        description: 'Use temporary phone numbers to effectively protect your personal information and prevent spam SMS and harassment calls'
      }
    },
    howToUseTitle: 'How to Use',
    howToUseSubtitle: 'Three simple steps to easily receive SMS codes',
    steps: {
      select: {
        title: 'Select Phone Number',
        description: 'Choose a number from our temporary phone number list that meets your needs'
      },
      use: {
        title: 'Use Phone Number',
        description: 'Enter your selected temporary phone number on the website or app that requires verification'
      },
      receive: {
        title: 'Receive SMS Code',
        description: 'View the received SMS code in real-time on our platform to complete your registration or login'
      }
    },
    platformAlt: 'UltraThink Data Sharing Platform'
  },

  // Authentication
  auth: {
    login: 'Login',
    twoFactorCode: 'Two-factor code',
    twoFactorCodePlaceholder: 'Enter the 6-digit authenticator code',
    twoFactorPrompt: 'Verify your sign-in with your authenticator app.',
    register: 'Register',
    welcomeBack: 'Welcome back, please login to your account',
    createAccount: 'Create a new account to start using UltraThink',
    username: 'Username',
    password: 'Password',
    setPassword: 'Set Password',
    confirmPassword: 'Confirm Password',
    inviteCode: 'Invite Code',
    usernamePlaceholder: 'Enter username',
    inviteCodePlaceholder: 'Enter invite code (optional)',
    passwordPlaceholder: 'Enter password',
    confirmPasswordPlaceholder: 'Enter password again',
    agreeToTerms: 'I have read and agree to',
    userAgreement: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    userAgreementTitle: 'Terms of Service',
    privacyPolicyTitle: 'Privacy Policy',
    agreeButton: 'I have read and agree',
    readFullAgreement: 'Please read the complete agreement content, scroll to the bottom to click agree',
    messages: {
      fillComplete: 'Please fill in complete information',
      passwordMismatch: 'Password entries do not match',
      agreeRequired: 'Please read and agree to the Terms of Service and Privacy Policy',
      registerSuccess: 'Registration successful, please login',
      loginSuccess: 'Login successful',
      loginFailed: 'Login failed:',
      registerFailed: 'Registration failed:',
      turnstileRequired: 'Please complete the human verification first',
      turnstileLoadFailed: 'Human verification failed to load, please refresh and try again',
      turnstileConfigMissing: 'Human verification site key is not configured',
      turnstileVerifyFailed: 'Human verification failed, please refresh and try again',
      turnstileRetrying: 'Human verification failed. Retrying...',
      turnstileRetryExhausted: 'Human verification is temporarily unavailable. Switch networks, disable VPN, or try another browser.',
      turnstileDomainUnauthorized: 'Human verification is not configured for this domain. Please contact support.',
      turnstileConfigError: 'Human verification configuration error. Please contact support.',
      platformBlocked: 'Platform has detected SMS template for this company and needs to be blocked, please contact platform customer service.'
    },
    // Add connectors and other text
    connector: {
      and: 'and'
    },
    errors: {
      loginFailed: 'Login failed:',
      registerFailed: 'Registration failed:'
    },
    userAgreementContent: {
      welcome: 'Welcome to use the services provided by UltraThink Data Sharing Platform (hereinafter referred to as "this platform"). Please carefully read and fully understand all the contents of this agreement before registering as a user of this platform. When you register, log in or use the services of this platform, it means that you are an overseas Chinese and have agreed and accepted all the terms of this agreement.',
      serviceDescription: {
        title: '1. Service Description',
        content1: '1.1 This platform is committed to providing users with SMS data sharing services, helping overseas Chinese protect the privacy of personal mobile phone numbers and reduce the risk of personal information leakage when using various applications and services.',
        content2: '1.2 All business of this platform comes from third-party access, and this platform itself does not provide any self-operated business.',
        content3: '1.3 This platform only provides data sharing services and does not support sending SMS, receiving voice verification codes or other communication services.'
      },
      usageRestrictions: {
        title: '2. Usage Restrictions',
        content1: '2.1 This platform is limited to legal and legitimate purposes, including but not limited to: email registration, game account registration or rebinding and other normal application scenarios.',
        content2: '2.2 This platform automatically blocks the following high-risk project types, including but not limited to:',
        risks: [
          'Financial services (banking, payment, lending, etc.)',
          'Government and public services',
          'Dating and social platforms',
          'Travel and sharing services',
          'Mainstream e-commerce platforms (such as Alibaba, Tencent, etc.)',
          'Wool-pulling behaviors that violate platform rules',
          'Other projects that may involve high risks'
        ]
      },
      disclaimer: {
        title: '3. Disclaimer',
        content1: '3.1 This platform does not guarantee whether the verification code numbers received are brand new numbers. Once the verification code is successfully received, the service is considered complete.',
        content2: '3.2 Users should judge the legality and risks of using this service by themselves and be responsible for their own actions. If users ignore this agreement and use the platform services, causing any losses or legal responsibilities, they shall be borne by the users themselves, and this platform shall not bear any responsibility.',
        content3: '3.3 This platform is not responsible for the service quality, stability or security of any third-party platforms.',
        content4: '3.4 If you are the corresponding platform and find SMS templates of your company on this platform that need to be blocked, please contact platform customer service.'
      },
      userObligations: {
        title: '4. User Obligations',
        content1: '4.1 Users promise not to use this platform to engage in any illegal or criminal activities.',
        content2: '4.2 Users must not use this platform for fraud, cyber attacks, information theft and other bad behaviors.',
        content3: '4.3 Users must not use this platform to circumvent real-name authentication, identity verification and other regulatory requirements.'
      },
      accountManagement: {
        title: '5. Account Management',
        content1: '5.1 Users should properly keep their accounts and passwords. Losses caused by account theft, password leakage, etc. shall be borne by the users themselves.',
        content2: '5.2 For users who violate this agreement or laws and regulations, this platform has the right to suspend or terminate their account usage rights.'
      },
      agreementModification: {
        title: '6. Agreement Modification',
        content1: '6.1 This platform reserves the right to modify this agreement at any time, and the modified agreement will be published on the platform.',
        content2: '6.2 If you do not agree with the modified agreement, you should immediately stop using the platform services; continued use is deemed as your acceptance of the modified agreement.'
      },
      legalApplication: {
        title: '7. Legal Application',
        content1: '7.1 The conclusion, execution, interpretation and dispute resolution of this agreement shall be governed by the local laws where you use it.',
        content2: '7.2 In case of disputes related to this agreement, both parties should resolve them through friendly consultation; if consultation fails, either party may file a lawsuit with a competent people\'s court.'
      },
    },
    privacyPolicyContent: {
      welcome: 'This privacy policy explains how UltraThink Data Sharing Platform (hereinafter referred to as "this platform") collects, uses and protects your personal information. We attach great importance to your privacy protection. Please read this privacy policy carefully before using our services.',
      informationCollection: {
        title: '1. Information Collection',
        content: '1.1 To provide services, we may collect the following information:',
        items: [
          'Account information: username, password and other registration information',
          'Transaction information: recharge, consumption and other service usage records',
          'Device information: device identifiers, IP addresses, browser types, etc.',
          'Log information: operation records of your use of our services'
        ]
      },
      informationUsage: {
        title: '2. Information Usage',
        content: '2.1 We use the collected information for:',
        items: [
          'Providing, maintaining and improving our services',
          'Processing your transaction requests',
          'Customer support and problem solving',
          'Preventing fraud and improving security',
          'Analyzing service usage and optimizing user experience'
        ]
      },
      informationSharing: {
        title: '3. Information Sharing',
        content: '3.1 Except for the following circumstances, we will not share your personal information with any third parties:',
        items: [
          'With your explicit consent',
          'Third-party partners necessary to complete services (such as payment processors)',
          'Compliance with legal and regulatory requirements or government law enforcement requests',
          'Protecting the rights, property or safety of this platform, users or the public'
        ]
      },
      informationSecurity: {
        title: '4. Information Security',
        content1: '4.1 We take reasonable security measures to protect your personal information and prevent unauthorized access, use or disclosure.',
        content2: '4.2 However, please note that the Internet environment is not absolutely secure, and we cannot guarantee the absolute security of information transmission.'
      },
      userRights: {
        title: '5. User Rights',
        content: '5.1 You have the following rights regarding your personal information:',
        items: [
          'Access and correct your personal information',
          'Delete your account (which may result in inability to continue using our services)',
          'Withdraw your previously granted consent'
        ]
      },
      cookiesAndTechnology: {
        title: '6. Cookies and Similar Technologies',
        content: '6.1 We use cookies and similar technologies to provide and improve service experience, including remembering your preference settings, analyzing usage patterns, etc.'
      },
      policyUpdate: {
        title: '7. Policy Updates',
        content1: '7.1 We may update this privacy policy from time to time, and the updated policy will be published on the platform.',
        content2: '7.2 For major changes, we may notify you in obvious ways. Continued use of our services indicates your acceptance of the revised privacy policy.'
      },
      contactUs: {
        title: '8. Contact Us',
        content: '8.1 If you have any questions about this privacy policy or need to exercise your rights, please contact us through the customer service channels provided by the platform.'
      },
    }
  },

  // User Center
  userCenter: {
    title: 'User Center',
    personalInfo: 'Personal Information',
    username: 'Username:',
    role: 'Role:',
    securitySettings: 'Security Settings',
    twoFactorTitle: 'Two-factor authentication (2FA)',
    twoFactorDescription: 'In addition to your password, sign-in requires a time-based code from an authenticator app.',
    twoFactorQrAlt: 'Two-factor enrollment QR code',
    twoFactorScanOrEnter: 'Scan this QR code with an authenticator app or enter the secret manually.',
    twoFactorOpenApp: 'Open in authenticator app',
    twoFactorCode: 'Authenticator code',
    twoFactorCodePlaceholder: '6-digit code',
    twoFactorConfirm: 'Confirm and enable',
    twoFactorDisableConfirm: 'Verify and disable',
    twoFactorEnabled: 'Two-factor authentication enabled',
    twoFactorDisabled: 'Two-factor authentication disabled',
    twoFactorStatusFailed: 'Failed to load two-factor status',
    twoFactorSetupFailed: 'Failed to set up two-factor authentication',
    twoFactorDisableFailed: 'Failed to disable two-factor authentication',
    twoFactorCodeInvalid: 'Enter a valid 6-digit code',
    twoFactorDisableFieldsRequired: 'Enter your current password and 6-digit code',
    password: 'Current password',
    passwordPlaceholder: 'Enter your current password',
    rechargeRecords: 'Recharge Records',
    changePassword: 'Change Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    oldPasswordPlaceholder: 'Enter current password',
    newPasswordPlaceholder: 'Enter new password (at least 6 characters)',
    confirmNewPasswordPlaceholder: 'Enter new password again',
    confirmChange: 'Confirm Change',
    submitting: 'Submitting...',
    userAvatar: 'User Avatar',
    validation: {
      oldPasswordRequired: 'Please enter current password',
      newPasswordRequired: 'Please enter new password',
      newPasswordTooShort: 'New password must be at least 6 characters',
      newPasswordSameAsOld: 'New password cannot be the same as current password',
      confirmPasswordRequired: 'Please confirm new password',
      passwordMismatch: 'Password entries do not match'
    },
    messages: {
      changePasswordSuccess: 'Password changed successfully',
      changePasswordFailed: 'Password change failed:',
      changePasswordError: 'Error changing password:',
      parseUserInfoFailed: 'Failed to parse user information:'
    }
  },

  // Recharge Records
  rechargeRecords: {
    title: 'Recharge Records',
    qrCodePay: 'QR Code Payment',
    usdt: 'USDT Recharge',
    orderNo: 'Order Number',
    amount: 'Amount',
    originalAmount: 'Original Amount',
    feeAmount: 'Fee',
    rechargeStatus: 'Status',
    rechargeTypeName: 'Recharge Type',
    payType: 'Payment Method',
    createTime: 'Created Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'to',
    loadFailed: 'Failed to load recharge records',
    loadError: 'Error loading recharge records',
    statuses: {
      success: 'Success',
      pending: 'Pending'
    }
  },

  // Balance
  balance: {
    title: 'Account Balance',
    current: 'Current Balance',
    recharge: 'Recharge',
    successRate: 'Success Rate'
  },

  // Account
  account: {
    balance: 'Account Balance',
    successRate: 'SMS Success Rate',
    rechargeNow: 'Recharge Now',
    balanceInsufficientTitle: 'Insufficient Balance Notice:',
    balanceInsufficientDesc: 'If you get a number but don\'t receive SMS, the platform will temporarily freeze the fee for that number (5 minutes), calculated as: number fee + freeze fee'
  },

  // Project Operations
  project: {
    operationTitle: 'Project Operations',
    searchPlaceholder: 'Search projects...',
    searchButton: 'Search Projects',
    searchProject: 'Search Project',
    internationalProjects: 'International',
    internationalProjectsButton: 'International Projects',
    currentChannel: 'Current Channel',
    project: 'Project',
    channelCode: 'Channel Code',
    numberSegment: 'Number Segment',
    copyAPI: 'Copy API',
    switch: 'Switch',
    channel: 'Channel:',
    price: 'Price:',
    connectionCode: 'Connection Code:',
    getApiParams: 'Get API Parameters',
    switchChannel: 'Switch Channel',
    noProjectsFound: 'No related projects found',
    noProjectsHint: 'If the project does not exist, it may be due to service fluctuation. Please search a few more times before applying',
    enterKeywords: 'Please enter keywords to search for projects',
    operationGuideTitle: 'Project Operation Guide:',
    operationGuides: [
      '1. Enter keywords in the search box to find projects (e.g., "Walmart", "Amazon")',
      '2. Choose appropriate channels - pay attention to price and success rate. We recommend selecting recently created channels',
      '3. Use advanced options to specify card type, specific numbers, or number segments',
      '4. After obtaining a number, use it on the corresponding platform to send verification codes. The system will automatically poll for SMS'
    ],
    smsTemplateIssueTitle: 'Why can\'t I receive SMS after sending verification code?',
    smsTemplateIssues: [
      '1. The SMS template is likely incorrect. For example, you searched for "Walmart" but your actual SMS template is "[Amazon Technology] Your verification code is 123456". In this case, you won\'t receive the SMS. You should search for "Amazon Technology" - the content inside the brackets [].',
      '2. If you still can\'t receive SMS, use your own phone number to receive a verification code first, then check if it matches the project you searched for. If there are discrepancies, please submit the updated template on the platform.',
      '3. Important: This platform does not support TikTok, Momo, Alipay, WeChat, and similar consumer apps. It only supports gaming and privacy-focused projects. Please don\'t recharge if it doesn\'t meet your needs.'
    ],
    newPhoneIssueTitle: 'Why isn\'t my registered number new?',
    newPhoneIssue: '1. The platform cannot determine if a number is new - users must verify this themselves. Please don\'t recharge if it doesn\'t meet your requirements.',
    codeReceptionTipTitle: 'SMS Reception Tips:',
    codeReceptionTips: [
      '1. Choosing high success rate channels can improve SMS delivery success',
      '2. SMS success rates vary by time period and may be lower during peak hours',
      '3. If no SMS is received for a long time, we recommend releasing the number and getting a new one',
      '4. Some projects may have specific number segment restrictions - use advanced options to configure these settings'
    ]
  },

  // Advanced Options
  advancedOptions: {
    title: 'Advanced Options',
    collapse: 'Collapse Advanced Options',
    expand: 'Expand Advanced Options',
    cardType: 'Card Type',
    cardTypeOptions: {
      unlimited: 'Unlimited',
      physical: 'Physical Card',
      virtual: 'Virtual Card'
    },
    specificPhone: 'Specific Number',
    includePrefix: 'Include Prefixes',
    includePrefixPlaceholder: 'Optional, e.g.: 138,139',
    excludePrefix: 'Exclude Prefixes',
    excludePrefixPlaceholder: 'Optional, e.g.: 133,134',
    province: 'Province',
    provincePlaceholder: 'Optional, e.g.: Xinjiang',
    getPhoneLoading: 'Getting...',
    getPhoneButton: 'Get Number'
  },

  // Phone Number List
  phoneList: {
    title: 'Phone List',
    usageTipTitle: 'Usage Tips:',
    usageTips: [
      '1. Click to copy number, code or content',
      '2. Status shows time left before timeout',
      '3. Release button frees the number',
      '4. Blacklist prevents getting same number'
    ],
    copyAllPhones: 'Copy All',
    releaseAllPhones: 'Release All',
    audioToggle: 'Sound',
    lastGetTimeTestTitle: 'Please help me test when no code arrives',
    lastGetTimeTestTip: 'After getting the number, remember this last code time, then send your business SMS verification code and observe whether this "Last Code Time" will update within two minutes and let me know',
    headers: {
      index: '#',
      connectionCode: 'Code',
      location: 'Region',
      phoneNumber: 'Number',
      verificationCode: 'SMS Code',
      smsContent: 'Message',
      lastGetTime: 'Last Code Time',
      chargeAmount: 'Charge',
      status: 'Status',
      actions: 'Actions'
    },
    status: {
      label: 'Status',
      waiting: 'Waiting...',
      waitingSms: 'Waiting SMS...',
      received: 'Received',
      timeout: 'Timeout'
    },
    actions: {
      release: 'Release',
      blacklist: 'Block',
      releaseAll: 'Release All',
      copyAllNumbers: 'Copy All Numbers',
      autoSaveData: 'Auto-save data',
      autoSaveDataHint: 'When enabled, the first verification code for each number is downloaded automatically. If your browser asks where to save files, a save dialog will appear. Disable that browser setting to save directly to the default download folder.'
    },
    audio: {
      enable: 'Enable Audio Alert',
      disable: 'Disable Audio Alert',
      on: 'Audio On',
      off: 'Audio Off'
    },
    emptyState: 'No numbers yet, click "Get Number" to start',
    noPhones: 'No phone numbers',
    getPhone: 'Get Number',
    gettingPhone: 'Getting...',
    getPhoneHint: 'Please select a project and channel first, then get a number'
  },

  // Recharge Dialog
  recharge: {
    title: 'Account Recharge',
    viewRecords: 'Recharge Records',
    cardRecharge: 'Card Recharge',
    usdtRecharge: 'USDT Recharge',
    easyPayRecharge: 'QR Code Payment',
    easypay: {
      helpTitle: 'QR Code Payment Instructions',
      help1: 'QR code payment is processed through a third-party platform and may take a few minutes to arrive. If the funds have not arrived after half an hour, please contact customer service and provide a screenshot showing successful payment. We will handle it as soon as possible.',
      help2: 'Supports Alipay and WeChat Pay, but there will be processing fees charged by the payment provider(5%), not related to the platform.',
      help3: 'Please do not recharge if you are not familiar with the usage or have not read the platform agreement.'
    },
    cardNumber: 'Card Number',
    cardNumberLabel: 'Card Number',
    cardNumberPlaceholder: 'Enter card number',
    cardNumberRequired: 'Please enter card number',
    recharging: 'Recharging...',
    rechargeButton: 'Recharge',
    confirmRecharge: 'Confirm Recharge',
    cardShop: 'Card Shop',
    usdtNoticeTitle: 'Recharge Notice, Please Read Carefully',
    usdtNotices: [
      'Coin purchase rate will reference OKEx rate, do not close this window during transaction',
      'Do not use exchange internal transfers, use standard on-chain withdrawal transfers (TRC20), otherwise arrival cannot be monitored',
      'Since USDT is blockchain transaction, if you transfer to wrong address or amount (including decimals), recharge cannot succeed and cannot be reversed',
      'Successful USDT recharge will give 10% bonus of recharge amount'
    ],
    usdtProcessTitle: 'USDT Recharge Process',
    amount: 'Amount',
    amountPlaceholder: 'Please select recharge amount',
    amountOptions: {
      '50': '50 CNY',
      '100': '100 CNY',
      '200': '200 CNY',
      '500': '500 CNY',
      '1000': '1000 CNY'
    },
    customAmount: 'Custom Amount',
    customAmountLabel: 'Custom Recharge Amount',
    customAmountPlaceholder: 'Please enter recharge amount (100-5000)',
    amountRange: 'Amount Range',
    amountTooLow: 'Recharge amount cannot be less than 100 CNY',
    amountTooHigh: 'Recharge amount cannot exceed 5000 CNY',
    confirmAmount: 'Confirm Amount',
    transactionInfoTitle: 'Transaction Info, Current Rate:',
    copyPrompt: 'Try clicking wallet address or amount to copy directly👇',
    usdtWalletQrAlt: 'USDT Wallet QR Code',
    transactionTips: 'Copy wallet address or scan QR code above to complete transaction (only supports on-chain transactions, not other internal transactions). After successful transfer, system will recharge corresponding coins. Contact customer service for recharge issues',
    rechargeLog: 'Recharge Log',
    rechargeLogTitle: 'Recharge Log',
    autoCheckMessage: 'System is automatically detecting recharge status...',
    defaultRechargeLog: 'Waiting to select recharge amount...',
    tipsTitle: 'Important Notice',
    tips: {
      tip1: 'Please save your <strong style="color: #ef4444;">contact information</strong> and <strong style="color: #ef4444;">order number (not the order number from your Alipay or WeChat, but the order number generated by the card issuer, usually starting with FK or QS)</strong> when purchasing. If payment is completed without receiving card key, you can query again',
      tip2: 'Platform numbers are <strong style="color: #ef4444;">uploaded by merchants</strong>, unknown if new or used. You can identify through app password recovery methods',
      tip3: 'Many merchants sell on <strong style="color: #ef4444;">multiple platforms</strong> to maximize revenue. Your account <strong style="color: #ef4444;">may be stolen</strong>, merchants <strong style="color: #ef4444;">may change cards anytime</strong>. Please <strong style="color: #ef4444;">do not bind important services</strong>',
      keywords: {
        contact: 'contact information',
        orderNumber: 'order number',
        merchantUpload: 'merchant uploaded',
        multiplePlatforms: 'multiple platforms',
        accountStolen: 'may be stolen',
        changeCard: 'may change cards anytime',
        importantBusiness: 'do not bind important services'
      }
    },
    // Quick recharge related
    smallAmountPlaceholder: 'Or custom amount (5-300 coins)',
    paymentMethod: 'Payment Method',
    alipay: 'Alipay',
    wechatPay: 'WeChat Pay',
    pleaseSelectAmount: 'Please select or enter recharge amount',
    pleaseSelectPaymentMethod: 'Please select payment method',
    amountRangeError: 'Recharge amount must be between 5-300 coins',
    creating: 'Creating...',
    createOrder: 'Create Order ({amount} coins)',
    orderCreatedSuccess: 'Order created successfully',
    createOrderFailed: 'Failed to create order',
    paymentInfo: 'Payment Information',
    orderNo: 'Order No',
    paymentUrlTip: 'Please click the link below to complete payment:',
    goToPay: 'Go to Pay',
    scanToPayTip: 'Scan to Pay',
    paymentQrAlt: 'Payment QR Code',
    paymentPending: 'Payment Pending',
    paymentSuccess: 'Payment Successful',
    paymentSuccessMessage: 'Payment successful! Balance updated',
    checking: 'Checking...',
    checkStatus: 'Check Status',
    checkStatusFailed: 'Failed to check payment status',
    // Fee related
    originalAmount: 'Recharge Amount',
    feeAmount: 'Fee',
    totalPayment: 'Total Payment',
    coins: ' coins'
  },

  // Project Search Dialog
  projectSearch: {
    title: 'Select Project',
    searchButton: 'Search',
    channel: 'Channel:',
    viewChannel: 'View Channel',
    noResults: 'No related projects found',
    noResultsTip: 'If project doesn\'t exist, it might be service fluctuation, don\'t rush to apply immediately, try searching a few more times',
    applyProject: 'Apply Project',
    searchInstruction: 'Enter keywords to search projects'
  },

  // Project Application Dialog
  projectApplication: {
    title: 'Apply Project',
    formTip: 'Fill in the received SMS content. Example: "[Game] Your verification code is 123456"',
    smsContentLabel: 'SMS Content Example',
    smsContentPlaceholder: 'Please fill in received SMS content example',
    submitButton: 'Submit Application',
    contentRequired: 'Please enter SMS content',
    contentLengthError: 'SMS content must be at least 2 characters long'
  },
  
  // Apply Project
  applyProject: {
    title: 'Apply for Project',
    applyButton: 'Apply for Project',
    contentExample: 'Enter the SMS content you received. Example: "[Game] Your verification code is 123456"',
    smsExample: 'SMS Content Example',
    submitButton: 'Submit Application'
  },

  // Channel Selection Dialog
  channelSelection: {
    title: 'Select Channel',
    headers: {
      channelCode: 'Channel Code',
      projectId: 'Project ID',
      price: 'Price',
      numberSegment: 'Number Segment',
      location: 'Location',
      status: 'Status',
      createTime: 'Create Time',
      lastSuccess: 'Last Success',
      actions: 'Actions'
    },
    selectChannel: 'Select This Channel',
    loadingChannels: 'Loading channels...',
    noChannels: 'No available channels',
    quickSwitch: 'Quick Switch Channel',
    countryFilter: 'Country Filter',
    allCountries: 'All Countries',
    searchCountry: 'Select or search country'
  },

  // Quick Channel Switch Dialog
  quickChannelSwitch: {
    title: 'Quick Switch Channel',
    price: 'Price:',
    location: 'Location:',
    numberSegment: 'Number Segment:',
    noChannelsInstruction: 'No available channels, please select channel through project search first'
  },

  // Notice Dialog
  notice: {
    title: 'Notice',
    autoCloseCountdown: 'Auto close in {count} seconds',
    autoCloseIn: 'Auto close in {seconds} seconds'
  },

  // Receive Records Page
  activity: {
    active: 'Black Friday',
    saved: 'Save {amount}',
    originalPrice: 'Original',
    actualPrice: 'Paid',
    discountAmount: 'Discount'
  },

  receiveRecords: {
    title: 'Receive Records',
    subtitle: 'View your SMS reception history',
    retentionNotice: 'SMS records are only retained for five days. If you need long-term storage, please export and save them yourself',
    channelCodeFilter: 'Channel Code',
    smsContentFilter: 'SMS Content',
    channelCodePlaceholder: 'Search channel code',
    smsContentPlaceholder: 'Search SMS content',
    recordsTitle: 'Reception Records',
    phoneTab: 'Phone Records',
    mailTab: 'Email Records',
    phoneRecordsTitle: 'Phone Records',
    mailRecordsTitle: 'Email Records',
    exportExcel: 'Export Excel',
    exporting: 'Exporting...',
    headers: {
      channelCode: 'Channel Code',
      amount: 'Amount',
      actualAmount: 'Paid',
      originalAmount: 'Original',
      discountAmount: 'Discount',
      activity: 'Activity',
      phoneNumber: 'Phone Number',
      verificationCode: 'Verification Code',
      smsContent: 'SMS Content',
      time: 'Time'
    },
    copyVerificationCode: 'Copy Verification Code',
    loadingRecords: 'Loading records...',
    noRecords: 'No reception records',
    noMailRecords: 'No email code records',
    mailHeaders: {
      project: 'Project',
      email: 'Email Address',
      verificationCode: 'Verification Code',
      amount: 'Paid',
      status: 'Status',
      receivedTime: 'Received At'
    }
  },

  // Message Processing Page
  messageProcessing: {
    title: 'Message Processing',
    subtitle: 'View system messages sent by the platform',
    feedbackButton: 'Feedback',
    messageList: 'Message List',
    unreadMessages: 'Unread Messages',
    readMessages: 'Read Messages',
    systemMessage: 'System Message',
    unreadStatus: 'Unread',
    loadingMessages: 'Loading messages...',
    noMessages: 'No messages',
    feedbackTitle: 'Feedback',
    feedbackContent: 'Feedback Content',
    feedbackPlaceholder: 'Please describe the issues you encountered or provide suggestions...',
    sendFeedback: 'Send Feedback',
    chargingIssues: 'Charging Issues',
    chargingGuidance: 'For card purchases, please include your contact information or order number (starting with FK or QS, not the order number from Alipay or WeChat). For USDT recharge, please contact customer service directly',
    usageIssues: 'Usage Issues',
    usageGuidance: 'Please carefully read the Q&A in the FAQ section, which can solve 99% of your questions'
  },

  // Ticket Center
  ticketCenter: {
    kicker: 'Support Center',
    title: 'Ticket Center',
    subtitle: 'Submit a categorized ticket, keep the conversation in one timeline, and track its progress.',
    centerSubtitle: 'Review support tickets and platform messages in one place, with a unified unread reminder.',
    tabsLabel: 'Ticket center content',
    ticketsTab: 'My Tickets',
    messagesTab: 'Messages',
    create: 'New Ticket',
    createFirst: 'Create Your First Ticket',
    createAnother: 'Create Another Ticket',
    statusFilter: 'Filter tickets by status',
    unread: 'New update',
    emptyTitle: 'No Tickets Yet',
    emptyDescription: 'When something goes wrong, submit a ticket here and follow its progress.',
    selectTitle: 'Select a Ticket',
    selectDescription: 'Messages, status changes, and the resolution will appear here.',
    createdAt: 'Created',
    relatedRecord: 'Related record:',
    waitUserHint: 'Support is waiting for more information. Your reply will move the ticket back to In Progress.',
    resolvedHint: 'Support marked this issue as resolved. Confirm and close it, or reply to reopen it.',
    timeline: 'Ticket conversation timeline',
    loadOlderMessages: 'Load earlier messages',
    addReply: 'Add Information',
    replyPlaceholder: 'Add details that can help us investigate…',
    replyPrivacyHint: 'Never send passwords, tokens, API keys, or complete payment credentials.',
    sendReply: 'Send Reply',
    reopenAndReply: 'Still Not Resolved — Reply',
    ticketEnded: 'This ticket has ended',
    ticketEndedHint: 'If you still need help, create a new ticket and reference this ticket number.',
    cancelTicket: 'Cancel Ticket',
    confirmClose: 'Confirm & Close',
    cancelConfirm: 'You cannot reply after cancelling. Cancel this ticket?',
    closeConfirm: 'Confirm that the issue is resolved and close this ticket?',
    cancelSuccess: 'Ticket cancelled',
    closeSuccess: 'Ticket closed',
    userCancelledReason: 'Cancelled by user',
    createTitle: 'Submit a New Ticket',
    problemType: 'Issue Type',
    problemTypePlaceholder: 'Select the closest issue type',
    relatedType: 'Related Record Type',
    relatedTypeRequired: 'Select a related record type',
    relatedId: 'Related Record ID',
    relatedIdPlaceholder: 'Enter the ID of your own record',
    relatedRecordPlaceholder: 'Select one of your records',
    noRelatedRecords: 'No related records found',
    relatedRequiredHint: 'Recharge, wallet, and withdrawal issues must use one of your records. Ownership is verified again by the server.',
    amount: 'Amount',
    traceId: 'TRACE_ID',
    traceIdPlaceholder: 'For API errors, enter the TRACE_ID from the response',
    description: 'Description',
    descriptionPlaceholder: 'Describe what happened, the expected result, and the actual result. Include an order number when relevant, but never a password or key.',
    descriptionHint: 'Enter 5–1000 characters so support can investigate accurately.',
    privacyNotice: 'Tickets are for investigation and communication. They cannot directly credit a wallet, approve a withdrawal, or unlock an account. Never submit passwords, tokens, API keys, or recovery phrases.',
    submitTicket: 'Submit Ticket',
    validationIncomplete: 'Check the highlighted fields before submitting',
    validationTypeRequired: 'Select an issue type',
    validationRelatedTypeRequired: 'Select a related record type',
    validationRelatedIdRequired: 'Select or enter a related record ID, or clear the record type if it is not needed',
    validationRelatedIdFormat: 'The related record ID must be a positive integer',
    validationContentRequired: 'Enter a description',
    validationContentLength: 'The description must contain 5–1000 characters',
    createSuccess: 'Ticket {ticketNo} created',
    replySuccess: 'Reply sent',
    filters: {
      all: 'All',
      ended: 'Ended'
    },
    statuses: {
      status0: 'Pending',
      status1: 'In Progress',
      status2: 'Waiting for You',
      status3: 'Resolved',
      status4: 'Closed',
      status5: 'Cancelled'
    },
    types: {
      type1: 'Number / Task',
      type2: 'Number / Verification Code',
      type3: 'Projects / Exclusive Projects',
      type4: 'Recharge / Wallet',
      type5: 'Developer Withdrawal',
      type6: 'Account & Security',
      type7: 'Developer API',
      type8: 'Feature Suggestion',
      type9: 'Other'
    },
    relatedTypes: {
      type1: 'SMS Flow',
      type2: 'SMS Task',
      type3: 'SMS Project',
      type4: 'Project Application',
      type5: 'Exclusive Project Application',
      type6: 'EasyPay Recharge',
      type7: 'USDT Recharge',
      type8: 'Card Key',
      type9: 'Wallet Flow',
      type10: 'Developer Withdrawal'
    },
    sender: {
      you: 'You',
      support: 'Support',
      system: 'System'
    }
  },

  // Mobile Specific
  mobile: {
    // Header Status Bar
    header: {
      balance: 'Balance',
      recharge: 'Recharge',
      receiveCode: 'Receive SMS'
    },
    
    // Project List
    projectList: {
      title: 'Select Project',
      searchPlaceholder: 'Search project name',
      noProjects: 'No projects available',
      projectId: 'Project ID',
      available: 'Available',
      viewChannels: 'View Channels',
      back: 'Back',
      guide: {
        summaryTitle: 'Didn\'t receive the code or is the latest code time updated?',
        summary: 'First receive an SMS with your own number on the target app or website, then search and select the exact project named in the SMS keyword.',
        expand: 'How to choose the right project',
        collapse: 'Collapse project guide',
        stepsTitle: 'Follow these steps to save time',
        stepOne: 'Use your own number on the target app or website, not a number selected on this platform, to test registration or login and receive an SMS code.',
        stepTwo: 'Check the keyword inside the brackets 【】 in the SMS content.',
        stepThree: 'Return to this platform, search for that project name, and then get a phone number to receive the SMS normally.',
        exampleTitle: 'Example: Amazon',
        exampleSms: 'The SMS says 【Amazon】 Your verification code is 123456. Please complete verification within five minutes.',
        exampleSearch: 'Search for “Amazon” on the platform. You may see several projects such as “Amazon” and “Amazon Technology”.',
        exampleChoice: 'Choose “Amazon”, which must exactly match the keyword inside the SMS brackets.',
        missingTitle: 'Can\'t find the project?',
        missingContent: 'Send the complete SMS content to customer service so the project can be checked.',
        warning: 'Applications for restricted services such as Chinese government, banking, Tencent, Alibaba, and Didi businesses are prohibited.'
      }
    },
    
    // Channel List
    channelList: {
      title: 'Select Channel',
      titleWithCount: 'Select Channel ({count} items)',
      noChannels: 'No channels available',
      noChannelsHint: 'No channels available, please search for a project first',
      channelId: 'Channel ID',
      price: 'Price',
      successRate: 'Success Rate',
      available: 'Available',
      select: 'Select',
      back: 'Back'
    },
    
    // Recharge
    recharge: {
      title: 'Recharge',
      method: 'Payment Method',
      cardRecharge: 'Card Recharge',
      usdtRecharge: 'USDT Recharge',
      
      // Card Recharge
      card: {
        input: 'Card Number',
        inputPlaceholder: 'Please enter card number',
        submit: 'Recharge',
        submitting: 'Processing...',
        success: 'Recharge successful',
        failed: 'Recharge failed'
      },
      
      // USDT Recharge
      usdt: {
        title: 'USDT Recharge',
        notice: 'Important Notes - Please Read Carefully',
        noticeItems: [
          'Payment Method: Transfer USDT using TRC20 network to our address',
          'Blockchain transactions are irreversible. Wrong address or amount cannot be recovered',
          'Get 10% bonus on successful USDT recharge'
        ],
        amount: 'USDT Amount',
        amountPlaceholder: 'Select recharge amount',
        amountOptions: {
          50: '50 USDT',
          100: '100 USDT',
          200: '200 USDT',
          500: '500 USDT',
          1000: '1000 USDT'
        },
        transactionInfo: 'Transaction Info',
        transactionInfoTitle: 'Transaction Info',
        copyPrompt: 'Click to copy',
        walletAddress: 'Wallet Address',
        checkingStatus: 'Auto-checking payment status every 5 seconds...',
        notDetected: 'Payment not detected yet. Please confirm transfer completed. Auto-check continues...',
        detected: 'Success: {amount} USDT received',
        log: 'Recharge Log',
        qrCodeAlt: 'USDT Wallet QR Code'
      }
    },
    
    // Phone Info
    phoneInfo: {
      phoneNumber: 'Number',
      message: 'Message',
      verificationCode: 'Code',
      smsContent: 'SMS Content',
      lastGetTime: 'Last Code Time',
      time: 'Time',
      copySuccess: 'Copied',
      release: 'Release',
      clear: 'Clear',
      clearAll: 'Clear All'
    },
    
    // Get Phone
    getPhone: {
      button: 'Get Number',
      getting: 'Getting...',
      success: 'Success',
      failed: 'Failed',
      noBalance: 'Insufficient balance',
      selectProject: 'Please select a project',
      selectChannel: 'Please select a channel'
    },
    
    // Status
    status: {
      waiting: 'Waiting',
      success: 'Success',
      failed: 'Failed',
      timeout: 'Timeout',
      released: 'Released',
      available: 'Available',
      unavailable: 'Unavailable',
      normal: 'Normal',
      disabled: 'Disabled'
    }
  },

  // Referral Rewards Page
  referralRewards: {
    title: 'Referral Rewards',
    subtitle: 'Invite friends to use UltraThink and earn permanent rewards',
    rewardDescription: 'Reward Description',
    rewardText: 'After successful referral, you will permanently enjoy 10% of the user\'s recharge coins and 50% commission from subsequent coin consumption',
    promotionLink: 'Your Exclusive Promotion Link',
    copyLink: 'Copy Link',
    copied: 'Copied ✓',
    inviteStats: 'Invitation Statistics',
    invitedCount: 'Invited Count',
    withdrawableAmount: 'Withdrawable Amount (Coins)',
    applyWithdraw: 'Apply Withdraw',
    convertToCard: 'Convert to Card',
    inviteDetails: 'Invitation Details',
    inviteHeaders: {
      username: 'Username',
      registerTime: 'Register Time',
      status: 'Status'
    },
    statusActive: 'Active',
    statusInactive: 'Inactive',
    noInviteRecords: 'No invitation records',
    convertCardTitle: 'Convert to Card',
    cardType: 'Card Type',
    quantity: 'Quantity',
    cardOptions: {
      '5': '5 Coins',
      '10': '10 Coins',
      '50': '50 Coins',
      '100': '100 Coins'
    },
    generateCard: 'Generate Card',
    queryUnusedCards: 'Query Unused Cards',
    cardList: 'Card List',
    cardHeaders: {
      cardNumber: 'Card Number',
      amount: 'Amount (Coins)',
      createTime: 'Create Time'
    },
    clickToCopy: 'Click row to copy card number'
  },

  // Withdrawal
  withdraw: {
    applyTitle: 'Apply for Withdrawal',
    recordsTitle: 'Withdrawal Records',
    viewRecords: 'Withdrawal Records',
    availableBalance: 'Available Balance',
    minAmount: 'Minimum Withdrawal Amount',
    feeRate: 'Fee Rate',
    usdtFeeNote: 'USDT withdrawal requires a markup of 0.3 + 3U based on OKEx exchange rate',
    withdrawAmount: 'Withdrawal Amount',
    withdrawAmountPlaceholder: 'Please enter withdrawal amount',
    minAmountTip: 'Minimum withdrawal amount is {min} CNY',
    usdtAddress: 'USDT TRC20 Address',
    usdtAddressPlaceholder: 'Please enter USDT TRC20 address',
    usdtAddressTip: 'TRC20 address starts with T, 34 characters long',
    remark: 'Remark',
    remarkPlaceholder: 'Optional, you can note the purpose of withdrawal',
    fee: 'Fee',
    actualAmount: 'Actual Amount Received',
    cancel: 'Cancel',
    submit: 'Submit Application',

    // Form validation errors
    errors: {
      amountRequired: 'Please enter withdrawal amount',
      amountMustBePositive: 'Withdrawal amount must be greater than 0',
      amountExceedsBalance: 'Withdrawal amount cannot exceed available balance',
      amountBelowMinimum: 'Withdrawal amount cannot be lower than minimum withdrawal amount',
      addressRequired: 'Please enter USDT TRC20 address',
      addressInvalid: 'USDT TRC20 address format is incorrect (must start with T, 34 characters)'
    },

    // Status
    status: {
      pending: 'Pending',
      approved: 'Approved',
      paid: 'Paid',
      completed: 'Completed',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
      unknown: 'Unknown Status'
    },

    // Withdrawal record headers
    recordHeaders: {
      createTime: 'Application Time',
      amount: 'Withdrawal Amount',
      fee: 'Fee',
      actualAmount: 'Actual Amount',
      usdtAddress: 'USDT Address',
      status: 'Status',
      actions: 'Actions'
    },

    // Message prompts
    messages: {
      balanceInsufficient: 'Insufficient withdrawable balance',
      balanceBelowMinimum: 'Insufficient withdrawable balance, minimum withdrawal amount is {min} CNY',
      configLoadFailed: 'Failed to load withdrawal configuration, please try again later',
      enterAmount: 'Please enter withdrawal amount',
      amountBelowMinimum: 'Withdrawal amount cannot be lower than {min} CNY',
      amountExceedsBalance: 'Withdrawal amount exceeds available balance',
      enterUsdtAddress: 'Please enter USDT TRC20 address',
      invalidUsdtAddress: 'USDT TRC20 address format is incorrect, please check',
      applySuccess: 'Withdrawal application submitted, please wait for review',
      applyFailed: 'Withdrawal application failed, please try again later',
      recordsFetchFailed: 'Failed to fetch withdrawal records',
      confirmCancelWithdraw: 'Are you sure you want to cancel this withdrawal application?',
      userCancelled: 'User cancelled',
      cancelSuccess: 'Withdrawal cancelled',
      cancelFailed: 'Failed to cancel withdrawal',
      noRecords: 'No withdrawal records',
      detailFetchFailed: 'Failed to fetch withdrawal details'
    },

    // Withdrawal details
    detail: {
      title: 'Withdrawal Details',
      viewDetail: 'View Details',
      basicInfo: 'Basic Information',
      timeInfo: 'Time Information',
      auditInfo: 'Audit Information',
      withdrawId: 'Withdrawal ID',
      createTime: 'Application Time',
      auditTime: 'Audit Time',
      payTime: 'Payment Time',
      completeTime: 'Completion Time',
      auditAdmin: 'Auditor',
      payAdmin: 'Payer',
      completeAdmin: 'Completer',
      adminRemark: 'Admin Remark',
      rejectReason: 'Rejection Reason',
      userRemark: 'User Remark',
      noRemark: 'None',
      notCompleted: 'Not Completed'
    }
  },

  // API Docs Page
  apiDocs: {
    title: 'API Documentation',
    subtitle: 'Integrate with UltraThink SMS platform through API to provide data sharing services for your applications',
    noticeTitle: 'Important Notes',
    noticeText: 'Please take a few minutes to read the following instructions:',
    noticeItems: [
      'API is designed for efficiency, please do not abuse it. All calls require a sleep of 1S or more',
      'Excessive requests will result in account suspension',
      'If you encounter problems during integration, please provide feedback promptly, we will handle it as soon as possible',
      'It is recommended to get verification codes at most 100 times, if not obtained, there may really be none',
      'To ensure the server can run normally and stably, the number of phone numbers obtained through API at one time is adjusted to 20',
      'If you do not get a phone number, you must call the blacklist phone interface to blacklist the phone and release the task at the same time',
      'Those who previously used POST access do not need to modify (interface request parameters are exactly the same), this time GET method request is added, access is simpler'
    ],
    apiSections: {
      authentication: 'API Authentication',
      login: 'Login to get token',
      getBalance: 'Get user balance',
      getPhone: 'Get phone number',
      getCode: 'Get verification code',
      mailReceive: 'Email Receiving',
      blacklistPhone: 'Blacklist phone number',
      releasePhone: 'Release number'
    },
    requestParams: 'Request Parameters',
    requestExample: 'Request Example',
    responseExample: 'Response Example',
    tableHeaders: {
      param: 'Parameter',
      required: 'Required',
      type: 'Type',
      description: 'Description'
    },
    paramDescriptions: {
      channelId: 'Channel ID, available from the Get API Parameters button on the Receive SMS page',
      scope: 'Only use this number prefix; leave blank for no restriction (e.g. 138)',
      scopeBlack: 'Exclude this number prefix; leave blank for no restriction (e.g. 138)'
    },
    mailApi: {
      token: 'Token obtained after API login',
      serviceCode: 'Email service code from the email receiving page',
      domain: 'Email domain, for example gmail.com',
      supplier: 'Email supplier; defaults to 1 (Bower)',
      codeDescription: 'Pass activationId to read the local order status and verification code. WAITING_CODE means the background task is still polling; this endpoint does not call the supplier synchronously.',
      releaseDescription: 'Pass activationId to release an unreceived email order owned by the current Token.'
    },
    exampleCode: 'Integration Example Code',
    languageTabs: {
      python: 'Python',
      java: 'Java'
    },
    apiCredentials: {
      accessTitle: 'API Access Settings',
      title: 'API Credentials',
      description: 'You can use API credentials to access our API services. Please keep your credentials safe.',
      whitelistTitle: 'IP Whitelist',
      whitelistDescription: 'Only saved IPs can log in with API credentials. Whitelist changes do not alter credentials.',
      credentialsDescription: 'View or generate the API username and password, managed separately from the whitelist.',
      securityEnabled: 'Protection enabled',
      getCredentials: 'Get API Credentials',
      loading: 'Loading...',
      apiUsername: 'API Username',
      apiPassword: 'API Password',
      apiIpWhitelist: 'API Login IP Whitelist',
      apiIpWhitelistPlaceholder: 'Enter allowed API login IPs, separated by commas, spaces, or new lines, e.g. 1.2.3.4, 5.6.7.8',
      apiIpWhitelistTip: 'Separate multiple IPs with commas, spaces, or new lines. Changes take effect after saving.',
      apiIpWhitelistRequired: 'Please enter the API login IP whitelist',
      addCurrentIp: 'Add Current IP',
      saveWhitelist: 'Save Whitelist',
      savingWhitelist: 'Saving...',
      whitelistSaved: 'IP whitelist saved',
      whitelistSaveError: 'Failed to save IP whitelist',
      getCurrentIp: 'Get Current IP',
      gettingCurrentIp: 'Loading...',
      currentIpTitle: 'Current IP',
      currentIpMessage: 'Current IP',
      copyCurrentIp: 'Copy IP',
      currentIpEmpty: 'No current IP was returned',
      currentIpError: 'Failed to get current IP. Please try again later.',
      close: 'Close',
      securityWarning: 'Security Warning',
      securityMessage: 'Please keep your API credentials safe and do not share them with others. API login is only allowed from whitelisted IPs. If your credentials are leaked, please contact customer service.',
      dangerTitle: 'Reset API Credentials',
      dangerDescription: 'Old credentials will stop working immediately and the current session will be signed out.',
      resetCredentials: 'Reset Credentials',
      resetConfirmTitle: 'Confirm Reset Credentials',
      resetConfirmMessage: 'After resetting credentials, the old credentials will be immediately invalidated and you will be forced to log out. Are you sure you want to continue?'
    },
    authenticationInstructions: {
      title: 'About API Authentication:',
      description: 'This platform uses API Username, API Password, and an IP whitelist for authentication. Save the whitelist and retrieve credentials as separate actions.',
      step1: '1. Add allowed IPs in the IP Whitelist section and click "Save Whitelist"',
      step2: '2. From a whitelisted IP, use API Username and API Password to call the login endpoint to get token',
      step3: '3. Use the obtained token to call other API endpoints',
      step4: '4. The token is permanently valid, only needs to login once',
      step5: '5. After resetting credentials, old credentials will be immediately invalidated and need to login again to get new token',
      tokenNote: 'About Token:',
      tokenMessage: 'The login endpoint using API credentials only needs to be called once, the obtained token is permanently valid. The token represents your API identity, please keep it safe. After resetting API credentials, you need to use the new API credentials to login again to get a new token.'
    }
  },

  // Contact Page
  contact: {
    title: 'Contact Support',
    redirecting: 'Redirecting to customer service Telegram...',
    contactNow: 'Contact Now',
    contactUsAlt: 'Contact Us'
  },

  // 404 Page
  notFound: {
    title: 'Page Not Found',
    description: 'Sorry, the page you visited does not exist or has been removed',
    backHome: 'Back to Home'
  },

  // Footer
  footer: {
    product: 'Product',
    support: 'Support',
    customerService: 'Customer Service',
    feedback: 'Feedback',
    aboutUs: 'About Us',
    mobileApp: 'Mobile App',
    internationalProjects: 'International Projects'
  },

  desktopDownload: {
    eyebrow: 'White Whale Desktop',
    title: 'Windows Desktop Client',
    subtitle: 'Use data receiving, records, API documentation, and tickets in a dedicated client with automatic updates.',
    platform: 'Windows x64',
    version: 'Current version v{version}',
    download: 'Download for Windows',
    fileSize: 'Installer size: about {size}',
    requirementsTitle: 'System requirements',
    requirementSystem: 'Windows 10 or Windows 11',
    requirementArch: '64-bit processor',
    requirementNetwork: 'A network connection that can access White Whale services',
    installTitle: 'Installation',
    unsignedNotice: 'If Windows displays a security warning during installation or use, select “Run anyway” to continue.',
    updateNotice: 'The client automatically checks for new versions and can install downloaded updates in the app.',
    unavailableNotice: 'Latest version information is temporarily unavailable. Please try again later.'
  },

  // International Projects
  internationalProjects: {
    title: 'International Projects',
    subtitle: 'View all countries and project services we currently support',
    searchPlaceholder: 'Search countries or projects...',
    allTypes: 'All Types',
    countries: 'Countries',
    projects: 'Projects',
    totalCountries: 'Supported Countries',
    totalProjects: 'Active Projects',
    filteredResults: 'Filtered Results',
    countriesTitle: 'Supported Countries',
    projectsTitle: 'Active Projects',
    noResults: 'No Results Found',
    noResultsDesc: 'Try searching with different keywords',
    projectTypes: {
      social: 'Social Media',
      dating: 'Dating & Networking',
      ecommerce: 'E-commerce',
      entertainment: 'Entertainment & Gaming',
      tech: 'Technology',
      payment: 'Payment & Finance',
      other: 'Others'
    }
  },

  // Cookie
  cookie: {
    consentTitle: 'Cookie Settings',
    consentDescription: 'We use cookies to enable normal website functionality, personalize content and ads, provide social media features, and analyze traffic.',
    acceptAll: 'Accept All Cookies',
    rejectAll: 'Reject All',
    cookieSettings: 'Cookie Settings',
    settingsDescription: 'You can choose to enable or disable different categories of cookies. Necessary cookies are required for normal website operation and cannot be disabled.',
    categories: {
      necessary: 'Necessary Cookies',
      analytics: 'Analytics Cookies',
      marketing: 'Marketing Cookies',
      preferences: 'Preference Cookies'
    },
    savePreferences: 'Save Preferences'
  },

  // Messages
  messages: {
    loginRequired: 'Please login first',
    searchKeywordRequired: 'Please enter search keywords',
    channelInfoNotFound: 'Channel information not found',
    channelConnectionSuccess: 'Channel connection successful',
    channelConnectionFailed: 'Channel connection failed',
    projectSelectionRequired: 'Please select a project first',
    channelSelectionRequired: 'Please select a channel first',
    selectChannelFirst: 'Please select a channel first',
    channelSelected: 'Channel selected',
    selectChannelFailed: 'Failed to select channel',
    searchFailed: 'Search failed',
    getChannelsFailed: 'Failed to get channels',
    applySuccess: 'Application successful',
    applyFailed: 'Application failed',
    rechargeFailed: 'Recharge failed',
    phoneNumberSuccess: 'Phone number obtained successfully',
    getCodeTimeout: 'Timeout getting verification code',
    codeReceived: 'Verification code received',
    tasksRestored: 'Restored {count} ongoing task(s)',
    phoneReleased: 'Number released',
    releaseSuccess: 'Release successful',
    releaseFailed: 'Release failed',
    blacklistSuccess: 'Number added to blacklist',
    blacklistFailed: 'Failed to blacklist number',
    allPhonesReleased: 'All numbers released',
    releaseAllSuccess: 'All numbers released successfully',
    releaseAllFailed: 'Failed to release all numbers',
    noPhonesToRelease: 'No phones to release',
    noPhonesToCopy: 'No phones to copy',
    copySuccess: 'Copied successfully',
    copyFailed: 'Copy failed',
    copyError: 'Copy error',
    selectAmountFirst: 'Please select recharge amount first',
    rechargeSuccess: 'Recharge successful!',
    rechargeProcessing: 'Recharge successful, loading latest balance...',
    usdtInfoFetchFailed: 'Failed to get USDT recharge info, please try again later',
    calcPriceFailed: 'Failed to calculate price, please try again later',
    calcUsdtPriceFailed: 'Failed to calculate USDT recharge amount, please try again later',
    invalidAmount: 'Please enter valid recharge amount',
    cardRechargeSuccess: 'Card recharge successful',
    cardRechargeFailed: 'Card recharge failed, please try again later',
    rechargeAmountSelected: 'You selected to recharge {amount} coins, need to pay {usdtAmount} USDT, expected to get {totalAmount} coins after successful recharge (including 10% bonus)',
    checkingRecharge: 'Checking recharge status...',
    autoCheckStopped: 'Auto detection stopped',
    loggedOut: 'Logged out successfully',
    loginRequiredForRewards: 'Please login first to view referral rewards',
    walletDataFetchFailed: 'Failed to fetch wallet data',
    inviteListFetchFailed: 'Failed to fetch invitation list',
    withdrawNotSupported: 'Withdrawal requires contacting customer service, processed within 24 hours. Only supports USDT(TRC20) with a 0.2 + 2 USDT handling fee added to current exchange rate',
    withdrawBalanceInsufficient: 'Insufficient balance for withdrawal',
    withdrawAmountTooLow: 'Withdrawal amount must be greater than 100 coins. We recommend using the card conversion feature',
    selectCardTypeAndQuantity: 'Please select card type and enter valid quantity',
    insufficientBalance: 'Insufficient balance! Generating card requires {required} coins, current balance {current} coins',
    insufficientBalanceMinimum: 'Insufficient balance, need at least 5 coins to generate card',
    cardGeneratedSuccess: 'Successfully generated {count} cards',
    unusedCardsFound: 'Found {count} unused cards',
    cardCopied: 'Card number copied to clipboard',
    feedbackRequired: 'Please enter feedback content',
    duplicateFeedbackWarning: 'Please do not submit the same feedback. Be patient and wait for customer service reply',
    feedbackSubmitSuccess: 'Feedback submitted successfully',
    feedbackSubmitFailed: 'Failed to submit feedback',
    generateCardKeysFailed: 'Failed to generate card keys',
    queryUnusedCardsFailed: 'Failed to query unused card keys'
  },

  // Console Messages
  console: {
    fetchReceiveRecordsFailed: 'Failed to fetch receive records:',
    copyFailed: 'Copy failed:',
    fetchWalletDataFailed: 'Failed to fetch wallet data:',
    fetchInviteListFailed: 'Failed to fetch invite list:',
    generateCardKeysFailed: 'Failed to generate card keys:',
    queryUnusedCardsFailed: 'Failed to query unused card keys:',
    submitFeedbackFailed: 'Failed to submit feedback:',
    fetchBalanceFailed: 'Failed to fetch balance:',
    fetchSuccessRateFailed: 'Failed to fetch success rate:',
    fetchRechargeListFailed: 'Failed to fetch recharge list:',
    fetchNoticesFailed: 'Failed to fetch notices:',
    fetchProjectSearchFailed: 'Failed to search projects:',
    fetchChannelsFailed: 'Failed to fetch channels:',
    selectChannelFailed: 'Failed to select channel:',
    submitProjectApplicationFailed: 'Failed to submit project application:',
    getPhoneFailed: 'Failed to get phone number:',
    releasePhoneFailed: 'Failed to release phone:',
    blacklistPhoneFailed: 'Failed to blacklist phone:',
    copyAllPhonesFailed: 'Failed to copy all phones:',
    releaseAllPhonesFailed: 'Failed to release all phones:',
    cardRechargeFailed: 'Card recharge failed:',
    calcUsdtPriceFailed: 'Failed to calculate USDT price:',
    checkRechargeFailed: 'Failed to check recharge status:',
    unknownError: 'Unknown error',
    fetchUnreadCountFailed: 'Failed to fetch unread message count:',
    updateGlobalLoginStateFailed: 'Failed to update global login state:',
    cookiePreferencesSaved: 'Cookie preferences saved:',
    parseUserInfoFailed: 'Failed to parse user information:',
    fetchMessagesFailed: 'Failed to fetch messages:',
    markMessageReadFailed: 'Failed to mark message as read:',
    parseCookiePreferencesFailed: 'Unable to parse saved cookie preferences'
  },

  // FAQ Page
  faq: {
    title: 'Frequently Asked Questions',
    questions: {
      noSms: {
        title: 'Why can\'t I receive SMS verification codes?',
        possibleReasons: 'Possible reasons:',
        reasons: [
          'Confirm that you have sent a verification code to the obtained phone number on the corresponding project application/website',
          'Phone number blocked by project risk control, try switching phone number or channel (recommend trying multiple numbers)',
          'Phone number has been used before, registration-related projects may not receive SMS but login might work',
          'Project doesn\'t support virtual numbers, try switching to physical card',
          'Higher-priced channels usually have better quality',
          'Popular apps (like TikTok, miHoYo, etc.) are hard to find first-time resources, basically can\'t receive verification codes during registration'
        ],
        note: 'Note: Channel card quality varies and is unrelated to the platform. No charge if SMS is not received!'
      },
      balanceIssue: {
        title: 'Why can\'t I get a number when I have balance but get insufficient balance error?',
        description: 'If you get a number but don\'t receive SMS, the platform will temporarily freeze the fee for that number (5 minutes)',
        calculation: 'Calculation: number fee + freeze fee'
      },
      specifyPhone: {
        title: 'How to specify a phone number?',
        answer: 'In the project selection area, there is an "Other optional items (expandable)" option. Expand it to specify a phone number.'
      },
      phoneNotFound: {
        title: 'Why can\'t I find the specified phone number?',
        reasons: [
          'You may have selected the wrong project pool',
          'If you\'re sure the pool is correct, the cards in the pool may have been replaced with new cards'
        ],
        tip: 'Friendly reminder: Maintain your accounts well, record usernames and passwords for login, don\'t expect phone numbers to last long'
      },
      phoneDuration: {
        title: 'How long can phone numbers be kept?',
        answer: 'This is determined by upstream suppliers, the platform cannot determine specific duration.'
      },
      projectNotFound: {
        title: 'Why can\'t I find projects in search?',
        reasons: [
          'We don\'t provide services for high-risk projects, if you can\'t find it, that project doesn\'t exist',
          'Search function is fuzzy search, try using keywords'
        ]
      },
      internationalCards: {
        title: 'Do you have international phone cards?',
        answer: 'We provide international phone cards, you can view supported countries and projects in the international projects list. https://www.qc86.shop/international-projects'
      },
      sendSms: {
        title: 'Can I send SMS? Can I receive voice SMS?',
        answer: 'Our service only supports receiving text SMS, does not support sending SMS or receiving voice SMS.'
      },
      unexpectedCharge: {
        title: 'Why was I charged unexpectedly?',
        explanations: [
          'SMS may be received before the countdown ends, even if you click stop getting, you may still receive it',
          'If you refresh the page during this time, the backend will still get phone numbers since you\'ve already sent verification codes',
          'Need to wait patiently for the complete countdown, if you refreshed the page, check for verification codes in receive records'
        ]
      },
      otherQuestions: {
        title: 'Have other questions?',
        answer: 'Open the Ticket Center, choose an issue type, and track support replies from the same ticket.'
      }
    },
    backupAddress: 'Backup Address'
  },

  // Mobile App Page
  mobileApp: {
    title: 'Mobile App',
    redirecting: 'Redirecting to mobile website...',
    imageAlt: 'Mobile App',
    visitButton: 'Visit Mobile Website'
  },

  // Payment Verification Page
  payVerify: {
    title: 'Payment Security Notice',
    subtitle: 'Please verify the following order information carefully',
    warningHeader: {
      title: 'Payment Security Notice',
      subtitle: 'Please verify the following order information carefully'
    },
    antiFraud: {
      title: 'Anti-Fraud Reminder',
      tips: {
        official: 'Official Recharge',
        officialDesc: 'This QR code is only for official platform coin recharge',
        fraud: 'Beware of Scams',
        fraudDesc: 'Never transfer money through QR codes sent by others',
        verify: 'Verify Information',
        verifyDesc: 'If you did not initiate this recharge, you may have encountered a scammer. Do not proceed with payment',
        contact: 'Have Questions',
        contactDesc: 'Please contact official customer service immediately for confirmation'
      }
    },
    orderInfo: {
      title: 'Order Information',
      orderNo: 'Order Number',
      rechargeAmount: 'Recharge Amount',
      actualPayment: 'Actual Payment',
      coins: 'Coins'
    },
    actions: {
      confirm: 'Confirm and Proceed to Payment',
      redirecting: 'Redirecting...',
      tip: 'You will be redirected to the payment page after clicking',
      retry: 'Retry'
    },
    status: {
      loading: 'Loading order information...',
      error: 'Failed to retrieve order information',
      missingParam: 'Missing order number parameter',
      networkError: 'Network request failed, please try again later',
      invalidLink: 'Invalid payment link'
    },
    contact: {
      text: 'If you have any questions, please contact official customer service'
    }
  }
}
